/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unread_Indicators_PlannedInputs */

const en_unread_indicators_planned = /** @type {(inputs: Unread_Indicators_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unread indicators · Planned for v2`)
};

const es_unread_indicators_planned = /** @type {(inputs: Unread_Indicators_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicadores no leídos · Planeados para v2`)
};

const fr_unread_indicators_planned = /** @type {(inputs: Unread_Indicators_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicateurs non lus · Prévu pour la v2`)
};

const de_unread_indicators_planned = /** @type {(inputs: Unread_Indicators_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungelesen-Markierungen · Geplant für v2`)
};

const id_unread_indicators_planned = /** @type {(inputs: Unread_Indicators_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indikator belum dibaca · Direncanakan untuk v2`)
};

/** @type {(inputs: Unread_Indicators_PlannedInputs) => LocalizedString} */
const ja_unread_indicators_planned = en_unread_indicators_planned;

/** @type {(inputs: Unread_Indicators_PlannedInputs) => LocalizedString} */
const zh_unread_indicators_planned = en_unread_indicators_planned;

/** @type {(inputs: Unread_Indicators_PlannedInputs) => LocalizedString} */
const ar_unread_indicators_planned = en_unread_indicators_planned;

/** @type {(inputs: Unread_Indicators_PlannedInputs) => LocalizedString} */
const it_unread_indicators_planned = en_unread_indicators_planned;

/** @type {(inputs: Unread_Indicators_PlannedInputs) => LocalizedString} */
const ru_unread_indicators_planned = en_unread_indicators_planned;

/** @type {(inputs: Unread_Indicators_PlannedInputs) => LocalizedString} */
const pt_unread_indicators_planned = en_unread_indicators_planned;

/** @type {(inputs: Unread_Indicators_PlannedInputs) => LocalizedString} */
const ko_unread_indicators_planned = en_unread_indicators_planned;

/**
* | output |
* | --- |
* | "Unread indicators · Planned for v2" |
*
* @param {Unread_Indicators_PlannedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const unread_indicators_planned = /** @type {((inputs?: Unread_Indicators_PlannedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unread_Indicators_PlannedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unread_indicators_planned(inputs)
	if (locale === "es") return es_unread_indicators_planned(inputs)
	if (locale === "fr") return fr_unread_indicators_planned(inputs)
	if (locale === "de") return de_unread_indicators_planned(inputs)
	if (locale === "ja") return ja_unread_indicators_planned(inputs)
	if (locale === "zh") return zh_unread_indicators_planned(inputs)
	if (locale === "ar") return ar_unread_indicators_planned(inputs)
	if (locale === "id") return id_unread_indicators_planned(inputs)
	if (locale === "it") return it_unread_indicators_planned(inputs)
	if (locale === "ru") return ru_unread_indicators_planned(inputs)
	if (locale === "pt") return pt_unread_indicators_planned(inputs)
	return ko_unread_indicators_planned(inputs)
});